import {Select} from "@chakra-ui/react";
import React from "react";

import {GenerateRecentMonthsForDropdown} from "./dateUtils";

// Build the Xtras 26→25 subtitle for a "MM/YYYY" value. Example: "11/2025" → "26.10 – 25.11".
function xtrasRangeSubtitle(value) {
    const [mm] = value.split('/');
    const endMonth = parseInt(mm, 10);
    const startMonth = endMonth === 1 ? 12 : endMonth - 1;
    const pad = (n) => String(n).padStart(2, '0');
    return `26.${pad(startMonth)} – 25.${pad(endMonth)}`;
}


export default function MonthDropdownSelection(props){

    const months = GenerateRecentMonthsForDropdown();
    const [selectedMonth, setSelectedMonth] = React.useState(props.value || '');
    // Opt-in flag — caller passes true only for an Xtras admin so the option labels
    // get a "· 26.MM – 25.MM" subtitle alongside the normal month name.
    const showXtrasSubtitle = props.showXtrasSubtitle === true;

    React.useEffect(() => {
        if (props.value !== undefined) setSelectedMonth(props.value);
    }, [props.value]);

    const handleDateChanged = (e) => {
        setSelectedMonth(e.target.value);
        props.handleSelectedMonth(e.target.value);
    };

    return(
        <Select
            marginRight='0px'
            width={showXtrasSubtitle ? '280px' : '190px'}
            pr='15px'
            onChange={handleDateChanged}
            value={selectedMonth}
        >
            <option value='' disabled hidden>בחר חודש</option>
            {months.map((month) => (
                <option key={month.value} value={month.value}>
                    {showXtrasSubtitle
                        ? `${month.label} · ${xtrasRangeSubtitle(month.value)}`
                        : month.label}
                </option>
            ))}
        </Select>
    )
}
